module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/cisco.73e741f3.svg";